module.exports = __webpack_public_path__ + "img/top-logo.adf6e35a.png";